import { ChevronLeft, ChevronRight, ChevronUp, ChevronDown } from 'lucide-react'
import { DayPicker } from 'react-day-picker'
import { cn } from '@/lib/utils'
import { buttonVariants } from '@/components/ui/button-variants'
const CalendarChevron = ({ orientation, className, ...props }) => {
  switch (orientation) {
    case 'right':
      return <ChevronRight className={cn('h-4 w-4', className)} {...props} />
    case 'up':
      return <ChevronUp className={cn('h-4 w-4', className)} {...props} />
    case 'down':
      return <ChevronDown className={cn('h-4 w-4', className)} {...props} />
    case 'left':
    default:
      return <ChevronLeft className={cn('h-4 w-4', className)} {...props} />
  }
}
function Calendar({ className, classNames, showOutsideDays = true, ...props }) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn('p-3', className)}
      classNames={{
        months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
        month: 'space-y-4',
        caption: 'flex justify-center pt-1 relative items-center',
        caption_label: 'text-sm font-medium',
        nav: 'space-x-1 flex items-center',
        nav_button: cn(
          buttonVariants({
            variant: 'outline',
          }),
          'h-8 w-8 bg-transparent p-0 opacity-50 hover:opacity-100',
        ),
        button_previous: 'absolute left-1',
        button_next: 'absolute right-1',
        month_grid: 'w-full border-collapse space-y-1',
        weekdays: 'flex',
        weekday: 'text-muted-foreground rounded-md w-8 font-normal text-xs',
        week: 'flex w-full mt-2',
        day: 'h-8 w-8 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20',
        day_button: cn(
          buttonVariants({
            variant: 'ghost',
          }),
          'h-8 w-8 p-0 font-normal aria-selected:opacity-100',
        ),
        range_end: 'day-range-end',
        selected:
          'bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground',
        today: 'bg-accent text-accent-foreground',
        outside:
          'day-outside text-muted-foreground aria-selected:bg-accent/50 aria-selected:text-muted-foreground',
        disabled: 'text-muted-foreground opacity-50',
        range_middle: 'aria-selected:bg-accent aria-selected:text-accent-foreground',
        hidden: 'invisible',
        ...classNames,
      }}
      components={{
        Chevron: CalendarChevron,
      }}
      {...props}
    />
  )
}
Calendar.displayName = 'Calendar'
export { Calendar }
